import React from 'react';
import { Button } from 'react-bootstrap';
import { TrashIcon } from './icons';

const EDIT_BUTTON_STYLE = {
  width: '42px',
  flexShrink: 0,
  padding: '0.375rem',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center'
};

/**
 * Submit (and optional delete) row for create/edit forms.
 * In edit mode: primary submit + delete button. In create mode: single full-width submit.
 * @param {boolean} isEditMode
 * @param {boolean} submitting
 * @param {boolean} [deleting]
 * @param {function} [onDelete]
 * @param {string} [submitLabel='Submit changes']
 * @param {string} [deleteTitle='Delete']
 * @param {boolean} [disabled] - Disable submit (e.g. no selection in edit mode)
 * @param {string} [createLabel='Create'] - Label for submit when not edit mode
 */
const FormSubmitRow = ({
  isEditMode,
  submitting,
  deleting = false,
  onDelete,
  submitLabel = 'Submit changes',
  deleteTitle = 'Delete',
  disabled = false,
  createLabel = 'Create'
}) => {
  if (isEditMode) {
    return (
      <div className="d-flex gap-2" style={{ width: '100%' }}>
        <Button
          variant="primary"
          type="submit"
          disabled={submitting || disabled}
          className="flex-grow-1"
          style={{ minWidth: 0 }}
        >
          {submitting ? 'Saving...' : submitLabel}
        </Button>
        <Button
          variant="outline-danger"
          type="button"
          title={deleteTitle}
          disabled={submitting || deleting || disabled}
          onClick={onDelete}
          style={EDIT_BUTTON_STYLE}
        >
          <TrashIcon />
        </Button>
      </div>
    );
  }
  return (
    <Button variant="primary" type="submit" disabled={submitting || disabled} className="w-100">
      {submitting ? 'Creating...' : createLabel}
    </Button>
  );
};

export default FormSubmitRow;
